define('plugin/client-login/view/ClientLoginLayoutModuleView',['require','lib/view/LayoutView','plugin/client-login/view/ClientLoginInfoModuleView','plugin/client-login/view/ClientLoginFormModuleView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ClientLoginInfoModuleView = require('plugin/client-login/view/ClientLoginInfoModuleView');
    var ClientLoginFormModuleView = require('plugin/client-login/view/ClientLoginFormModuleView');

    return LayoutView.extend({

        template: '#client_login_module',
        regions: {
            info: '#sb_client_info',
            form: '#sb_login_form'
        },
        childEvents: {
            'signIn': 'triggerSignIn',
            'signOut': 'triggerSignOut'
        },
        _formView: null,

        onBeforeShow: function() {
            this.showChildView('info', new ClientLoginInfoModuleView({
                model: this.getOption('clientModel')
            }));

            this._formView = new ClientLoginFormModuleView({
                model: this.model,
                clientModel: this.getOption('clientModel')
            });
            this.showChildView('form', this._formView);
        },

        triggerSignIn: function () {
            this.triggerMethod('signIn', {
                view: this
            });
        },

        triggerSignOut: function () {
            this.triggerMethod('signOut', {
                view: this
            });
        },

        triggerEvent: function (event) {
            this.triggerMethod(event, {
                view: this
            });
        },

        getDataToSignIn: function () {
            return this._formView.getDataToSignIn();
        }

    });

});
